import { render, staticRenderFns } from "./QuestionErrorSet.vue?vue&type=template&id=3228f5e9&"
import script from "./QuestionErrorSet.vue?vue&type=script&lang=js&"
export * from "./QuestionErrorSet.vue?vue&type=script&lang=js&"
import style0 from "./QuestionErrorSet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports